module.exports = __webpack_public_path__ + "img/ic_shipping_footer.d61b2c8b.svg";